document.addEventListener('DOMContentLoaded', function () {
    const copyButtons = document.querySelectorAll('.copy-code-button');
    const discountCodeElements = document.querySelectorAll('#discount-code');
    const successMessages = document.querySelectorAll('#copy-success');

    copyButtons.forEach((copyButton, index) => {
        const discountCodeElement = discountCodeElements[index];
        const successMessage = successMessages[index];
        const checkmarkIcon = successMessage? successMessage.querySelector('svg') : null;

        if (copyButton && discountCodeElement && checkmarkIcon) {
            copyButton.addEventListener('click', function () {
                const discountCode = discountCodeElement.textContent.trim();
                navigator.clipboard.writeText(discountCode).then(function () {
                    successMessage.style.display = 'flex';
                    copyButton.querySelector('span').innerHTML = 'Code Copied';

                    setTimeout(() => {
                        successMessage.style.display = 'none';
                        copyButton.querySelector('span').innerHTML = 'Copy Code';
                    }, 2000);
                }).catch(function (error) {
                    console.error('Copy failed', error);
                });
            });
        }
    });
});